import { Link } from 'react-router-dom';
import './index.scss';

export const OutrosProdutos = () => {

    return (
        <div className='outros-produtos'>
            <div className='title-outros-produtos'>
                <h1> Outros produtos para sua empresa </h1>
            </div>
            <div className='dados-outros-produtos'>
                <div>
                    <h1> [ Crédito ] </h1>
                    <p>
                        Temos uma diversidade de produtos
                        específicos para o mercado cambial além de
                        apetite para operações de maiores
                        complexidades. As aprovações de crédito
                        são ágeis e as exigências de garantia são
                        reduzidas.
                    </p>
                    <Link className='btn-style' to={"/produtos-de-credito"}> Ver os produtos </Link>
                </div>
                <div>
                    <h1> [ Proteção ] </h1>
                    <p>
                        Oferecemos produtos de hedge cambial
                        para total proteção de suas transações.
                        Temos como vantagens uma equipe de
                        tesouraria dedicada, com exigência reduzida
                        de chamada de margem além de um
                        menor custo de EPF.
                    </p>
                    <Link className='btn-style' to={"/produtos-de-protecao"}> Ver os produtos </Link>
                </div>
                <div>
                    <h1> [ Produtos exclusivos ] </h1>
                    <p>
                        Falamos com clientes todos os dias
                        e ouvimos suas dores e necessidades.
                        Por isso, voltamos nossos olhares para
                        problemas operacionais e não somente
                        transações de câmbio pura e simplesmente.
                    </p>
                    <a href='https://wa.me/5511973667387' target="_blank" rel="noopener noreferrer" className='btn-style'> Fale com um especialista </a>
                </div>
            </div>
        </div>

    )

}
